import debug from 'debug';
import * as actionTypes from './actions/actionTypes';

// Create debug namespace for login reducer
const debugReducer = debug('auth:login:reducer');

const initialState = {
    IsLoginInProgress: false,
    LoggedIn: false,
    sessionExpirationWarning: false,
    CurrentUser: null,
    LoginError: '',
    sessionTimerId: null,
    passwordExpired: false,
    redirectedToProfile: false,
    restoreLoginDone: false,
    userNamePasswordExpired: '',
    restoringLogin: false,
    impersonating: false
};

export const reducer = (state, action) => {
    state = state || initialState;
    debugReducer('Action dispatched: %s', action.type);

    if (action.type === actionTypes.USER_PASSWORD_EXPIRED) {
        
        return {
            ...state,
            userNamePasswordExpired: action.userName,
            passwordExpired: true
        };
    }
    if (action.type === actionTypes.USER_PROFILE_IS_NOT_COMPLETED_REDIRECTED) {
        return {
            ...state,
            redirectedToProfile: true
        };
    }

    if (action.type === actionTypes.USER_PASSWORD_CHANGED) {
        return {
            ...state,
            passwordExpired: false
        };
    }

    if (action.type === actionTypes.START_SESSION_TIMER) {
        return {
            ...state,
            sessionTimerId: action.sessionTimerId,
            sessionExpirationWarning: false
        };
    }

    if (action.type === actionTypes.SESSION_EXPIRATION_WARNING) {
        return {
            ...state,
            sessionExpirationWarning: true
        };
    }
    if (action.type === actionTypes.USER_LOGOUT) {
        debugReducer('User logged out, clearing state');
        return {
            ...state,
            IsLoginInProgress: false,
            LoggedIn: false,
            sessionTimerId: null,
            LoginError: '',
            sessionExpirationWarning: false,
            CurrentUser: null,
            redirectedToProfile: false

        };
    }
    if (action.type === actionTypes.REQUEST_REFRESH_TOKEN) {
        debugReducer('Token refresh requested');
        return {
            ...state,
            CurrentUser: null,
            sessionExpirationWarning: false
        };
    }

    if (action.type === actionTypes.RECEIVE_REFRESH_TOKEN) {
        debugReducer('Token refresh successful, userId: %s', action.authData?.userId);
        return {
            ...state,
            CurrentUser: action.authData,
            sessionExpirationWarning: false
        }
    }

    if (action.type === actionTypes.FAILED_REFRESH_TOKEN) {
        debugReducer('Token refresh failed');
        return {
            ...state,
            CurrentUser: null
        }
    }

    if (action.type === actionTypes.REQUEST_USER_LOGIN) {
        debugReducer('Login request started');
        return {
            ...state,
            IsLoginInProgress: true,
            LoginError: '',
            CurrentUser: null
        };
    }


    if (action.type === actionTypes.RESTORE_USER_LOGIN_STARTED) {
        debugReducer('Restore login started');
        return {
            ...state,
            CurrentUser: null,
            LoggedIn: false,
            restoreLoginDone: false,
            restoringLogin: true
        };
    }

    if (action.type === actionTypes.RESTORE_USER_LOGIN) {
        debugReducer('Restore login successful, userId: %s', action.authData?.userId);
        return {
            ...state,
            CurrentUser: action.authData,
            LoggedIn: true,
            restoreLoginDone: true,
            restoringLogin: false
        };
    }
    if (action.type === actionTypes.RESTORE_USER_LOGIN_FAILED) {
        debugReducer('Restore login failed');
        return {
            ...state,
            restoreLoginDone: true,
            restoringLogin: false
        };
    }

    if (action.type === actionTypes.RECEIVE_USER_LOGIN) {
        debugReducer('Login successful, userId: %s', action.authData?.userId);
        return {
            ...state,
            CurrentUser: action.authData,
            IsLoginInProgress: false,
            LoggedIn: true
        };
    }
    
    if(action.type === actionTypes.REQUEST_IMPERSONATE){
        debugReducer('Impersonation request started');
        return {
            ...state,
            impersonating: true
        }
    }
    else if (action.type === actionTypes.SUCCESS_IMPERSONATE){
        debugReducer('Impersonation successful');
        return {
            ...state,
            impersonating: false
        }
    }
    else if (action.type === actionTypes.FAILED_IMPERSONATE){
        debugReducer('Impersonation failed');
        return {
            ...state,
            impersonating: false
        }
    }

    if (action.type === actionTypes.USER_PROFILE_UPDATED) {
        return {
            ...state,
            CurrentUser:  {...state.CurrentUser, ...action.userInfo}
        }
    }

    if (action.type === actionTypes.FAILED_USER_LOGIN) {

        let errorInfo = {};
        if (action.serverResponse && action.serverResponse.data) {
            errorInfo = action.serverResponse.data;
        } else {
            errorInfo = action.serverResponse
                ? action.serverResponse
                : 'something went wrong with the login request';
        }

        debugReducer('Login failed: %o', errorInfo);
        return {
            ...state,
            CurrentUser: null,
            LoginError: errorInfo,
            IsLoginInProgress: false,
            LoggedIn: false
        };
    }

    return state;
};
